module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAASklEQVR42u3TMQ4AIAgDQOrHjS+vDyChNTI42JHhQmgAybjNiIY8jgCYzuxokwqwEAVIxAFKxAVKhORqqdiF5GEdyKpYQfgPmLIBz28XH69PIagAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon-first.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon-first.png
// module chunks = styles